import axios from 'axios'

const instance = axios.create({
    baseURL : 'https://tinder-backend-b.herokuapp.com',
})

export default instance;